<!-- If we have children we are a group -->
<li class="side-nav-item-group" *ngIf="navItem?.children?.length; else innerItem">
  <ul class="side-nav-group">
    <ftr-side-nav-item
      *ngFor="let navGroupitem of navItem.children"
      [navItem]="navGroupitem"
      (hide)="hide()"
    ></ftr-side-nav-item>
  </ul>
</li>

<ng-template #innerItem>
  <ftr-side-nav-item-inner [navItem]="navItem" (hide)="hide()"></ftr-side-nav-item-inner>
</ng-template>
